import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from './../Icon';

const CloseMiniButton = ({ onClick, size }) => {
  return (
    <div className={clsx('close-mini-button', `close-mini-button--${size}`)} onClick={onClick}>
      <Icon type="close" color="white" size={size !== 'default' ? 'big' : 'xs'} />
    </div>
  );
};

CloseMiniButton.propTypes = {
  size: PropTypes.oneOf(['default', 'm']),
};

CloseMiniButton.defaultProps = {
  size: 'default',
};

export default CloseMiniButton;
